import React from 'react';
import axios from 'axios';
import csrfToken from '../../../shared/meta';
import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

const base = '/api/v1/lwadmin/fund';

const headers = { 'X-CSRF-TOKEN': csrfToken() };

export function useGetFunds() {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}s`,
    method: 'GET',
  }, { manual: true });
}

export function useSearchFundsToImport(query) {
  const common = t => ({ params: { query: t } });

  const [state, q] = useAxios({
    url: `${base}s/import/search`,
    method: 'GET',
    ...common(query),
  }, { manual: true });

  const executeQuery = React.useCallback(t => q(common(t)), [q]);

  return [state, executeQuery];
}

export function useViewFundToImport(dataProviderId) {
  const common = id => ({ params: { data_provider_id: id } });

  const [state, q] = useAxios({
    url: `${base}s/import/view`,
    method: 'GET',
    ...common(dataProviderId),
  }, { manual: true });

  const executeQuery = React.useCallback(i => q(common(i)), [q]);

  return [state, executeQuery];
}

export function publishFund(id) {
  return axios({ headers, url: `${base}/${id}/publish`, method: 'PUT' });
}

export function unpublishFund(id) {
  return axios({ headers, url: `${base}/${id}/unpublish`, method: 'PUT' });
}

export function createFund(payload) {
  return axios.post(base, payload, { headers });
}

export function updateFund(id, payload) {
  return axios.put(`${base}/${id}`, payload, { headers });
}

export function setMemberRole(fundId, profileId, role) {
  return axios.post(`${base}/${fundId}/member/${profileId}/set_member_role`, { role }, { headers });
}

export function unsetMembersRoles(fundId) {
  return axios.post(`${base}/${fundId}/members/unset_members_roles`, { headers });
}

export function usePostQanda() {
  const [state, q] = useAxios({
    cache: { ignoreCache: true },
    url: `${base}/`,
    method: 'POST',
  }, { manual: true });

  const executeQuery = (fid, { questionId, answer }) => q({
    url: `${base}/${fid}/qanda`,
    data: { question_id: questionId, answer },
  });

  return [state, executeQuery];
}

export function usePutQanda() {
  const [state, q] = useAxios({
    cache: { ignoreCache: true },
    url: `${base}/`,
    method: 'PUT',
  }, { manual: true });

  const executeQuery = (fid, { questionId, id, answer }) => q({
    url: `${base}/${fid}/qanda/${id}`,
    data: { question_id: questionId, answer },
  });

  return [state, executeQuery];
}

export function useGetFundPerformanceFromDataProvider(id) {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}/${id}/get_performance_from_data_provider`,
    method: 'GET',
  }, { manual: true });
}

export function useGetFundFeesFromDataProvider(id) {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}/${id}/get_fees_from_data_provider`,
    method: 'GET',
  }, { manual: true });
}

export function useGetFundNetAssetsFromDataProvider(id) {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}/${id}/get_net_assets_from_data_provider`,
    method: 'GET',
  }, { manual: true });
}

export function activateFund(id) {
  return axios({ headers, url: `${base}/${id}/activate`, method: 'PUT' });
}

export function deactivateFund(id) {
  return axios({ headers, url: `${base}/${id}/deactivate`, method: 'PUT' });
}

export function approveFundDataReview(id, reviewId) {
  return axios({ headers, url: `${base}/${id}/data_review/${reviewId}/approve`, method: 'PUT' });
}
